import { render, staticRenderFns } from "./ModalVerMais.vue?vue&type=template&id=d2e81184"
import script from "./ModalVerMais.vue?vue&type=script&lang=js"
export * from "./ModalVerMais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports